import { useCallback, useEffect } from 'react'
import { DataService_Models_SurveyMode, OpenAPI, SurveyEngine_Models_Block, SurveyEngine_Models_DynamicResponse, SurveyEngine_Models_DynamicResponseResponse, SurveyEngine_Models_GetResponse, SurveyEngine_Models_GetResponseResponse, SurveyEngine_Models_GetValue, SurveyEngine_Models_GetValueResponse, SurveyEngine_Models_MultiResponseGrid, SurveyEngine_Models_MultiResponseResponse, SurveyEngine_Models_PlayValue, SurveyEngine_Models_PlayValueResponse, SurveyEngine_Models_Ranking, SurveyEngine_Models_RankingResponse, SurveyEngine_Models_RecordMessage, SurveyEngine_Models_RecordMessageResponse, SurveyEngine_Models_RecruitResponse, SurveyEngine_Models_Scale, SurveyEngine_Models_ScaleMatrix, SurveyEngine_Models_ScaleMatrixResponse, SurveyEngine_Models_SESurveyConfirmOperation, SurveyEngine_Models_Slider, SurveyEngine_Models_SliderResponse, SurveyEngine_Models_StartGridQuestion, SurveyEngine_Models_StartGridResponse, SurveyEngine_Models_Video, SurveyEngine_Models_VideoResponse, SurveyService_Models_AnnounceResponse } from '../api'
import { SurveyEngine_Models_Platform } from '../api/models/SurveyEngine_Models_Platform'
import { SurveyApiService } from '../api/services/SurveyApiService'
import { ScheduleState, UserResponse } from '../Common'
import { useSurveyCtx, useSurveyCtxDispatch, useUserResponseCtx } from '../Context/SurveyContext'
import { useGlobalCtx } from '../Context/GlobalContext'
import { useRecruitDispatchCtx } from '../Context/RecruitContext'
import { useBlockDispatchCtx } from '../Context/BlockContext'

export function useStartSurvey() {

  const surveyCtx = useSurveyCtx();
  const globalCtx = useGlobalCtx()
  let blockDispatchCtx = useBlockDispatchCtx();
  const  surveyCtxDispatch = useSurveyCtxDispatch()
  const recruitCtxDispatch = useRecruitDispatchCtx();
  let userResCtx = useUserResponseCtx();
  //const { getThemeKeyValueCommand } = useThemeKeyValues();

  const clearRecruitError = useCallback(() => {
    recruitCtxDispatch({ type: "RecruitError", value: false });
  }, [])

  const getRefreshAvailableSession = useCallback((surveySID: string) => {
    if (surveySID) {
      surveyCtxDispatch({ type: "setLoading", value: true });
      SurveyApiService.postV1SurveyNextQuestion(
        surveySID,
        SurveyEngine_Models_Platform.WEB,
        []
      ).then((data) => {
        surveyCtxDispatch({ type: "SetNextQuestion", value: data.command! });
        surveyCtxDispatch({ type: "clearAPIError", value: {} });
        userResCtx.current = [];
        surveyCtxDispatch({ type: "clearValidationError", value: [] });
        recruitCtxDispatch({ type: "ScheduleState", value: ScheduleState.SCHEDULE });
        if (data.command?.commandType === "SurveyComplete") {
          surveyCtxDispatch({ type: "setComplete", value: true });
        }
        else {
          surveyCtxDispatch({ type: "setLoading", value: false });
        }
      }).catch((e: any) => {
        console.log("Failed handelRecruitError" + e);
        surveyCtxDispatch({ type: "SetAPIError", value: e });
        surveyCtxDispatch({ type: "setLoading", value: false });
      });
    }
  }, [])
  const getSubmitPendingConfirmation = useCallback((surveySID: string, payLoad: SurveyEngine_Models_RecruitResponse, operation: SurveyEngine_Models_SESurveyConfirmOperation) => {
    if (surveySID) {
      surveyCtxDispatch({ type: "setLoading", value: true });
      SurveyApiService.postV1SurveySubmitPendingConfirmation(
        surveySID,
        SurveyEngine_Models_Platform.WEB,
        operation,
        payLoad.sessionIds!
      ).then((data) => {
        surveyCtxDispatch({ type: "clearAPIError", value: {} });
        userResCtx.current = [];
        surveyCtxDispatch({ type: "clearValidationError", value: [] });
        if (operation === SurveyEngine_Models_SESurveyConfirmOperation.PENDING_CONFIRMATION) {
          recruitCtxDispatch({ type: "ScheduleState", value: ScheduleState.CONFIRM });
          clearRecruitError();
          surveyCtxDispatch({ type: "setLoading", value: false });
        }
        else if (operation === SurveyEngine_Models_SESurveyConfirmOperation.REMOVE_FROM_ALL_SESSIONS) {
          getRefreshAvailableSession(surveySID);
        }

      }).catch((e: any) => {
        console.log("Failed Submit Pending Confirmation" + e);
        surveyCtxDispatch({ type: "SetAPIError", value: e });
        recruitCtxDispatch({ type: "RecruitError", value: true });
        getRefreshAvailableSession(surveySID);
      });
    }
  }, [])
  const getNextQuestionCommand = useCallback((surveySID: string, payLoad: UserResponse, isFirstTime: boolean = false) => {
    if (surveySID) {
      surveyCtxDispatch({ type: "setLoading", value: true });
      SurveyApiService.postV1SurveyNextQuestion(
        surveySID,
        SurveyEngine_Models_Platform.WEB,
        payLoad
      ).then((data) => {
        surveyCtxDispatch({ type: "SetNextQuestion", value: data.command! });
        surveyCtxDispatch({ type: "SetProgressBarCounter", value: data.command?.commandIndex! });
        if (isFirstTime) {
          surveyCtxDispatch({ type: "SetFirstCommandIndex", value: data.command?.commandIndex! });
        }
        surveyCtxDispatch({ type: "clearAPIError", value: {} });
        userResCtx.current = [];
        surveyCtxDispatch({ type: "clearValidationError", value: [] });

        if (data.command?.commandType === "Recruit") {
          clearRecruitError();
          recruitCtxDispatch({ type: "ScheduleState", value: ScheduleState.SCHEDULE });
        }

        if (data.command?.commandType === "SurveyComplete") {
          surveyCtxDispatch({ type: "setComplete", value: true });
        }
        else {
          surveyCtxDispatch({ type: "setLoading", value: false });
        }
      }).catch((e: any) => {
        console.log("Failed Next Question" + e);
        surveyCtxDispatch({ type: "SetAPIError", value: e });
        if (payLoad[0].commandType === "Recruit") {
          recruitCtxDispatch({ type: "RecruitError", value: true });
          getRefreshAvailableSession(surveySID);
        }
        surveyCtxDispatch({ type: "setLoading", value: false });
      });
    }
  }, []);

  const getAbandonSurvey = useCallback((surveySID: string) => {
    if (surveySID && surveyCtx.NextQuestion.commandType !== "SurveyComplete") {
      SurveyApiService.postV1SurveyAbandon(
        surveySID
      ).then((data) => {
        if (!data?.success) {
          console.log("Failed to Abandon Survey: " + data.msg)
        }
      }).catch((e: any) => {
        console.log("Failed Abandon Survey" + e);
      });
    }
  }, []);


  const getRefreshToken = useCallback((studyID: number, panelistID: number, postSurvey: boolean) => {

    if (studyID > 0) {
      SurveyApiService.postV1SurveyRefreshToken(studyID, panelistID, postSurvey)
        .then((data) => {
          if (data?.token) {
            OpenAPI.TOKEN = data.token
            console.log("refresh token success")
          }
          else
            console.log("failed to refresh token")
        }).catch((e: any) => {
          console.log("Failed refresh token" + e);
        });
    }
  }, []);

  const getPreviousQuestionCommand = useCallback((surveySID: string, showPreviousResponse: boolean) => {
    if (surveySID) {

      surveyCtxDispatch({ type: "setLoading", value: true });
      SurveyApiService.postV1SurveyPreviousQuestion(
        surveySID,
        SurveyEngine_Models_Platform.WEB,
        showPreviousResponse
      ).then((data) => {
        surveyCtxDispatch({ type: "SetNextQuestion", value: data.command! });
        surveyCtxDispatch({ type: "SetProgressBarCounter", value: data.command?.commandIndex! });
        surveyCtxDispatch({ type: "clearAPIError", value: {} });
        
        if (data.command!.commandType === "Block") {
          let blockCommand = data.command! as SurveyEngine_Models_Block;
          userResCtx.current = [];
          if (!blockCommand.keepOnPage) {
            if(showPreviousResponse)
            {
              blockDispatchCtx({ type: "UpdateIndex", value: blockCommand.commands?blockCommand.commands.length - 1 : 0});
              blockCommand.commands?.forEach((command) => {
                switch (command.commandType) {
                  case "Announce":
                    {
                      let ann_response: SurveyService_Models_AnnounceResponse = {
                        commandType: "Announce",
                        commandIndex: command.commandIndex,
                      }
                      userResCtx.current.push(ann_response);
                      break;
                    }
                  case "GetResponse":
                    {
                      let getResponse = command as SurveyEngine_Models_GetResponse;
                      let gr_defaultAns = getResponse.answers?.find(ans => ans.isSelected === true);
                      let gr_response: SurveyEngine_Models_GetResponseResponse = {
                        commandType: "GetResponse",
                        commandIndex: getResponse.commandIndex,
                        selectedId: gr_defaultAns?.id,
                        otherValue: gr_defaultAns?.isOpenEnded ? gr_defaultAns.otherValue : undefined
                      };
                      userResCtx.current.push(gr_response);
                      break;
                    }
                  case "DynamicResponse":
                    {
                      let dynamicResponse = command as SurveyEngine_Models_DynamicResponse
                      let dr_defaultAns = dynamicResponse.answers?.find(ans => ans.isSelected === true);
                      let dr_response: SurveyEngine_Models_DynamicResponseResponse = {
                        commandType: "DynamicResponse",
                        commandIndex: dynamicResponse.commandIndex,
                        selectedId: dr_defaultAns?.id,
                      };
                      userResCtx.current.push(dr_response);
                      break;
                    }
                  case "Scale":
                    {
                      let scale = command as SurveyEngine_Models_Scale
                      let sc_defaultAns = scale.answers?.find(ans => ans.isSelected === true);
                      let sc_response: SurveyEngine_Models_DynamicResponseResponse = {
                        commandType: "Scale",
                        commandIndex: scale.commandIndex,
                        selectedId: sc_defaultAns?.id,
                      };
                      userResCtx.current.push(sc_response);
                      break;
                    }
                  case "ScaleMatrix":
                    {
                      let scaleMatrix = command as SurveyEngine_Models_ScaleMatrix
                      const scaleMatrixResAnswers: SurveyEngine_Models_StartGridResponse[] = scaleMatrix.questions!.filter(question => question.defaultValue !== undefined).map((question: SurveyEngine_Models_StartGridQuestion) => {
                        let answer: SurveyEngine_Models_StartGridResponse = {
                          answerValue: question.defaultValue,
                          commandType: "StartGridResponse",
                          commandIndex: question.commandIndex
                        }
                        return answer;
                      });
                      let sm_response: SurveyEngine_Models_ScaleMatrixResponse = {
                        commandIndex: scaleMatrix.commandIndex,
                        commandType: "ScaleMatrix",
                        answers: scaleMatrixResAnswers
                      }
                      userResCtx.current.push(sm_response);
                      break;
                    }
                  case "Ranking":
                    {
                      let ranking = command as SurveyEngine_Models_Ranking
                      const rankingResAnswers: SurveyEngine_Models_StartGridResponse[] = ranking.questions!.filter(question => question.defaultValue !== undefined).map((question: SurveyEngine_Models_StartGridQuestion) => {
                        let answer: SurveyEngine_Models_StartGridResponse = {
                          answerValue: question.defaultValue,
                          commandType: "StartGridResponse",
                          commandIndex: question.commandIndex
                        }
                        return answer;
                      });
                      let rank_response: SurveyEngine_Models_RankingResponse = {
                        commandIndex: ranking.commandIndex,
                        commandType: "Ranking",
                        answers: rankingResAnswers
                      }
                      userResCtx.current.push(rank_response);
                      break;
                    }
                  case "GetValue":
                    {
                      let getValue = command as SurveyEngine_Models_GetValue
                      let gv_response: SurveyEngine_Models_GetValueResponse = {
                        commandIndex: getValue.commandIndex,
                        commandType: "GetValue",
                        value: getValue.defaultAnswer
                      }
                      userResCtx.current.push(gv_response);
                      break;
                    }
                  case "MultiResponse":
                    {
                      let multiResponse = command as SurveyEngine_Models_MultiResponseGrid
                      const mr_default = multiResponse.answers?.filter(ans => ans.isSelected === true).map((item) => item.id!);
                      let mr_response: SurveyEngine_Models_MultiResponseResponse = {
                        commandIndex: multiResponse.commandIndex,
                        commandType: "MultiResponse",
                        answerIds: mr_default
                      }
                      userResCtx.current.push(mr_response);
                      break;
                    }
                  case "PlayValue":
                    {
                      let playValue = command as SurveyEngine_Models_PlayValue
                      let pv_response: SurveyEngine_Models_PlayValueResponse = {
                        commandType: "PlayValue",
                        commandIndex: playValue.commandIndex,
                      }
                      userResCtx.current.push(pv_response);
                      break;
                    }  
                  case "RecordMessage":
                    {
                      let recordMessage = command as SurveyEngine_Models_RecordMessage
                      let rm_response: SurveyEngine_Models_RecordMessageResponse = {
                        commandType: "RecordMessage",
                        commandIndex: recordMessage.commandIndex,
                        value:recordMessage.defaultAnswer
                      }
                      userResCtx.current.push(rm_response);
                      break;
                    } 
                  case "SLIDER":
                    {
                      let slider = command as SurveyEngine_Models_Slider
                      let sl_response: SurveyEngine_Models_SliderResponse = {
                        commandType: "SLIDER",
                        commandIndex: slider.commandIndex,
                        value: String(slider.defaultValue)
                      }
                      userResCtx.current.push(sl_response);
                      break;
                    }
                  case "Video":
                    {
                      let video = command as SurveyEngine_Models_Video
                      let video_response: SurveyEngine_Models_VideoResponse = {
                        commandType: "Video",
                        commandIndex: video.commandIndex,
                      }
                      userResCtx.current.push(video_response);
                      break;
                    }                                                                             
                }
              });
            }
            else
            {
              blockDispatchCtx({ type: "UpdateIndex", value: 0 });
            }
          }
          
        }
        else
        {
          userResCtx.current = [];
        }
        surveyCtxDispatch({ type: "clearValidationError", value: [] });
      }).catch((e: any) => {
        console.log("Failed Previous Question" + e);
        surveyCtxDispatch({ type: "SetAPIError", value: e });
      }).finally(() => {
        surveyCtxDispatch({ type: "setLoading", value: false });
      });
    }
  }, [])

  useEffect(() => {
    let mode = DataService_Models_SurveyMode.PORTAL;
    switch (globalCtx.App.toLocaleLowerCase()) {
      case "portal": mode = DataService_Models_SurveyMode.PORTAL; break;
      case "engage": mode = DataService_Models_SurveyMode.ENGAGE; break; 
      case "ola": mode = DataService_Models_SurveyMode.OLA; break;
      case "qualmm": mode = DataService_Models_SurveyMode.QUALMM;break;
      case "register": mode = DataService_Models_SurveyMode.REGISTER;break;
      default: mode = DataService_Models_SurveyMode.PORTAL
    }
    if (globalCtx.PostSurvey === false) {
      if(globalCtx.App && !["portal","ola","qualmm","engage","register"].includes(globalCtx.App.toLocaleLowerCase()))
      {
        console.log("Query parameter app canntot be recognized ");
        surveyCtxDispatch({ type: "SetStartError", value:{}});
      }
      if(globalCtx.App === "qualmm" && !globalCtx.UUID)
      {
        console.log("Query parameter UUID canntot be null or empty for app QualMM/MM ");
        surveyCtxDispatch({ type: "SetStartError", value:{}});
      }
      else if (globalCtx.StudyId > 0 && globalCtx.PanelistId > 0) {
        surveyCtxDispatch({ type: "setLoading", value: true });
        OpenAPI.TOKEN = globalCtx.PanelistToken;
        SurveyApiService.postV1SurveyStartparticipant(SurveyEngine_Models_Platform.WEB, globalCtx.StudyId, globalCtx.PanelistId, false,
          {
            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            ipAddress: '127.0.0.1',
            uuid:globalCtx.App === 'qualmm'?globalCtx.UUID:'',
            surveyMode:mode
          }).then((surveyStartRes) => {
            OpenAPI.TOKEN = surveyStartRes.authToken!;

            surveyCtxDispatch({ type: "SetStartSurvey", value: surveyStartRes });
            surveyCtxDispatch({
              type: "timeZone", value: surveyStartRes.panelistTimeZone && surveyStartRes.panelistTimeZone!.length > 0 ?
                surveyStartRes.panelistTimeZone :
                Intl.DateTimeFormat().resolvedOptions().timeZone
            });
            document.title = surveyStartRes.studyDisplayName!;
            if (globalCtx.RedirectUrl) {
              surveyCtxDispatch({ type: "RedirectURL", value: globalCtx.RedirectUrl });
            }
            else if (surveyStartRes.returnUrl && surveyStartRes.returnUrl.length > 0) {
              surveyCtxDispatch({ type: "RedirectURL", value: surveyStartRes.returnUrl });
            }
            else {
              surveyCtxDispatch({ type: "RedirectURL", value: globalCtx.DomainName });
            }
            return surveyStartRes;
          }).then((surveyStartRes) => {
            getNextQuestionCommand(surveyStartRes.surveyInstanceId!, [], true)
          }).catch((e) => {
            console.log("Failed Start Survey" + e);
            //globalCtx.Theme === "" &&  globalCtxDispatch({type:"setTheme", value: "ARCS"});
            //globalCtx.Language === "" &&  globalCtxDispatch({type:"setLanguage", value: "en-US"});
            //globalCtxDispatch({type:"setLanguageResources", value: languageResources.en_US});
            surveyCtxDispatch({ type: "SetAPIError", value: e });
            // this need to set here just incase api fails we still need to set the redirect URL correctly
            if (globalCtx.RedirectUrl) {
              surveyCtxDispatch({ type: "RedirectURL", value: globalCtx.RedirectUrl });
            }
            else {
              surveyCtxDispatch({ type: "RedirectURL", value: globalCtx.DomainName });
            }
            surveyCtxDispatch({ type: "setLoading", value: false });
          })

      }
      else if (globalCtx.StudyId > 0) {
        surveyCtxDispatch({ type: "setLoading", value: true });
        SurveyApiService.postV1SurveyStart(SurveyEngine_Models_Platform.WEB, globalCtx.StudyId, false, globalCtx.PsGUID,
          {
            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            ipAddress: '127.0.0.1',
            uuid:globalCtx.App === 'qualmm'?globalCtx.UUID:'',
            surveyMode : mode
          }).then((surveyStartRes) => {
            OpenAPI.TOKEN = surveyStartRes.authToken!;
            document.title = surveyStartRes.studyDisplayName!;
            if (globalCtx.RedirectUrl) {
              surveyCtxDispatch({ type: "RedirectURL", value: globalCtx.RedirectUrl });
            }
            else if (surveyStartRes.returnUrl && surveyStartRes.returnUrl.length > 0) {
              surveyCtxDispatch({ type: "RedirectURL", value: surveyStartRes.returnUrl });
            }
            else {
              surveyCtxDispatch({ type: "RedirectURL", value: globalCtx.DomainName });
            }
            surveyCtxDispatch({ type: "SetStartSurvey", value: surveyStartRes });
            surveyCtxDispatch({
              type: "timeZone", value: surveyStartRes.panelistTimeZone && surveyStartRes.panelistTimeZone!.length > 0 ?
                surveyStartRes.panelistTimeZone :
                Intl.DateTimeFormat().resolvedOptions().timeZone
            });
            return surveyStartRes;
          }).then((surveyStartRes) => {
            getNextQuestionCommand(surveyStartRes.surveyInstanceId!, [], true)
          }).catch((e) => {
            console.log("Failed Start Survey" + e);

            //globalCtx.Theme === "" &&  globalCtxDispatch({type:"setTheme", value: "ARCS"});
            //globalCtx.Language === "" &&  globalCtxDispatch({type:"setLanguage", value: "en-US"});
            //globalCtxDispatch({type:"setLanguageResources", value: languageResources.en_US});

            surveyCtxDispatch({ type: "SetAPIError", value: e });
            // this need to set here just incase api fails we still need to set the redirect URL correctly
            if (globalCtx.RedirectUrl) {
              surveyCtxDispatch({ type: "RedirectURL", value: globalCtx.RedirectUrl });
            }
            else {
              surveyCtxDispatch({ type: "RedirectURL", value: globalCtx.DomainName });
            }
            surveyCtxDispatch({ type: "setLoading", value: false });
          })
      }
      else if (globalCtx.StudyIdentifier !== '') {
        surveyCtxDispatch({ type: "setLoading", value: true });
        SurveyApiService.postV1SurveyStart1(SurveyEngine_Models_Platform.WEB, globalCtx.StudyIdentifier, false, globalCtx.PsGUID,
          {
            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            ipAddress: '127.0.0.1',
            uuid:globalCtx.App === 'qualmm'?globalCtx.UUID:'',
            surveyMode : mode
          }).then((surveyStartRes) => {
            OpenAPI.TOKEN = surveyStartRes.authToken!;
            document.title = surveyStartRes.studyDisplayName!;
            if (globalCtx.RedirectUrl) {
              surveyCtxDispatch({ type: "RedirectURL", value: globalCtx.RedirectUrl });
            }
            else if (surveyStartRes.returnUrl && surveyStartRes.returnUrl.length > 0) {
              surveyCtxDispatch({ type: "RedirectURL", value: surveyStartRes.returnUrl });
            }
            else {
              surveyCtxDispatch({ type: "RedirectURL", value: globalCtx.DomainName });
            }
            surveyCtxDispatch({ type: "SetStartSurvey", value: surveyStartRes });
            surveyCtxDispatch({
              type: "timeZone", value: surveyStartRes.panelistTimeZone && surveyStartRes.panelistTimeZone!.length > 0 ?
                surveyStartRes.panelistTimeZone :
                Intl.DateTimeFormat().resolvedOptions().timeZone
            });
            return surveyStartRes;
          }).then((surveyStartRes) => {
            getNextQuestionCommand(surveyStartRes.surveyInstanceId!, [], true)
          }).catch((e) => {
            console.log("Failed Start Survey" + e);

            //globalCtx.Theme === "" &&  globalCtxDispatch({type:"setTheme", value: "ARCS"});
            //globalCtx.Language === "" &&  globalCtxDispatch({type:"setLanguage", value: "en-US"});
            //globalCtxDispatch({type:"setLanguageResources", value: languageResources.en_US});

            surveyCtxDispatch({ type: "SetAPIError", value: e });
            // this need to set here just incase api fails we still need to set the redirect URL correctly
            if (globalCtx.RedirectUrl) {
              surveyCtxDispatch({ type: "RedirectURL", value: globalCtx.RedirectUrl });
            }
            else {
              surveyCtxDispatch({ type: "RedirectURL", value: globalCtx.DomainName });
            }
            surveyCtxDispatch({ type: "setLoading", value: false });
          })
      }
      else {
        console.log("Failed Start Survey - Invalid Input");
        surveyCtxDispatch({ type: "SetStartError", value:{}});
      }
    }

  }, [globalCtx.StudyId, globalCtx.PanelistId, globalCtx.PsGUID, globalCtx.StudyIdentifier, surveyCtxDispatch, globalCtx.PanelistToken, globalCtx.RedirectUrl, globalCtx.DomainName, getNextQuestionCommand]);
  return { getNextQuestionCommand, getPreviousQuestionCommand, getRefreshToken, getAbandonSurvey, getSubmitPendingConfirmation };
}

